"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Dialog = require("../../shared/Dialog/DialogActions");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const api_1 = require("../../api");
const utils_1 = require("../../utils");
const constants_1 = require("../../constants");
const LandingActions_1 = require("../LandingActions");
const util_1 = require("util");
const react_bootstrap_1 = require("react-bootstrap");
const FontAwesome = require("react-fontawesome");
const mapDispatchToProps = dispatch => {
    return {
        openModal: modal => dispatch(LandingActions_1.openModal(modal))
    };
};
class ContactUsPart extends React.Component {
    constructor() {
        super();
        this.name = "";
        this.email = "";
        this.subject = "";
        this.message = "";
        this.state = {
            state: constants_1.ProgressState.None
        };
    }
    componentDidMount() {
        const homeItem = $('#homeItem');
        const contactItem = $('#contactItem');
        const topItem = $('#homeItem, #serviceItem, #aboutItem');
        if (contactItem.hasClass('active-item')) {
            homeItem.removeClass('active-item');
        }
        if (homeItem.hasClass('active-item')) {
            contactItem.removeClass('active-item');
        }
        contactItem.click(function () {
            contactItem.addClass('active-item');
            setTimeout(function () {
                $('html, body').animate({ scrollTop: $("#contact").offset().top });
                homeItem.removeClass('active-item');
            }, 100);
        });
        topItem.click(function () {
            contactItem.removeClass('active-item');
            // this.addClass('active-item');
            $('html, body').animate({ scrollTop: 0 });
        });
    }
    componentWillUnmount() {
        $('#contactItem').removeClass('active-item');
    }
    contact() {
        if (this.isValid()) {
            this.setState({ state: constants_1.ProgressState.Loading });
            api_1.doPost(api_1.API.v1.CONTACTUS.SEND, {
                name: this.name,
                email: this.email,
                subject: this.subject,
                message: this.message
            }).then(response => {
                this.name = "";
                this.email = "";
                this.subject = "";
                this.message = "";
                this.setState({ state: constants_1.ProgressState.Success });
                Dialog.showAlertDialog({
                    title: "Contact Us",
                    message: "Your message successfully sent."
                });
                $(':input').val('');
                $('textarea').val('');
                $('.help-block').empty();
            }).catch(error => {
                this.setState({ state: constants_1.ProgressState.Failed });
            });
        }
    }
    render() {
        return React.createElement("div", { id: "contact" }, React.createElement(react_bootstrap_1.Row, { className: "contact-bg" }, React.createElement(react_bootstrap_1.Col, { xs: 12, className: "text-center" }, React.createElement("h1", { className: "text-center" }, "CONTACT US")), React.createElement(react_bootstrap_1.Grid, null, React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6, className: "margin-15" }, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ bsSize: "large", controlId: "name" }, utils_1.FormUtils.formGroupAttributes(this.state.name)), React.createElement(react_bootstrap_1.InputGroup, null, React.createElement(react_bootstrap_1.InputGroup.Button, null, React.createElement(react_bootstrap_1.InputGroup.Addon, null, React.createElement(react_bootstrap_1.Image, { src: "../img/contact_us/name.png" }))), React.createElement(react_bootstrap_1.FormControl, { type: "text", placeholder: "Name", defaultValue: this.name, name: "name", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), utils_1.FormUtils.showErrorBlock(this.state.name))), React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ bsSize: "large", controlId: "email" }, utils_1.FormUtils.formGroupAttributes(this.state.email)), React.createElement(react_bootstrap_1.InputGroup, null, React.createElement(react_bootstrap_1.InputGroup.Button, null, React.createElement(react_bootstrap_1.InputGroup.Addon, null, React.createElement(react_bootstrap_1.Image, { src: "../img/contact_us/email.png" }))), React.createElement(react_bootstrap_1.FormControl, { type: "text", placeholder: "Email Address", defaultValue: this.email, name: "email", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), utils_1.FormUtils.showErrorBlock(this.state.email))), React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ bsSize: "large", controlId: "subject" }, utils_1.FormUtils.formGroupAttributes(this.state.subject)), React.createElement(react_bootstrap_1.InputGroup, null, React.createElement(react_bootstrap_1.InputGroup.Button, null, React.createElement(react_bootstrap_1.InputGroup.Addon, null, React.createElement(react_bootstrap_1.Image, { src: "../img/contact_us/Subject.png" }))), React.createElement(react_bootstrap_1.FormControl, { type: "text", placeholder: "Subject", name: "subject", defaultValue: this.subject, onChange: event => utils_1.FormUtils.dataChanged(event, this) })), utils_1.FormUtils.showErrorBlock(this.state.subject)))), React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6 }, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ bsSize: "large", controlId: "formControlsTextarea", className: "textarea" }, utils_1.FormUtils.formGroupAttributes(this.state.message)), React.createElement(react_bootstrap_1.InputGroup, null, React.createElement(react_bootstrap_1.InputGroup.Button, null, React.createElement(react_bootstrap_1.InputGroup.Addon, null, React.createElement(react_bootstrap_1.Image, { src: "../img/contact_us/message.png" }))), React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", placeholder: "Message", defaultValue: this.message, name: "message", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), utils_1.FormUtils.showErrorBlock(this.state.message))), React.createElement(react_bootstrap_1.Col, { xs: 12, className: "text-center send-form" }, React.createElement("a", { href: "javascript:void(0)", title: "Send", onClick: () => this.contact() }, React.createElement(react_bootstrap_1.Image, { src: '../img/home/button.png', responsive: true, className: "center-block imReady" }), React.createElement("span", { className: "buttonStyle send-btn" }, this.state.state === constants_1.ProgressState.Loading && React.createElement(FontAwesome, { name: "spinner", spin: true, fixedWidth: true }), this.state.state !== constants_1.ProgressState.Loading && "Send"))))));
    }
    isValid() {
        let valid = true;
        let updateState = this.state;
        if (validator.isEmpty(this.name)) {
            valid = false;
            updateState.name = {
                state: constants_1.ProgressState.Failed,
                errorMessage: "Name is required."
            };
        } else {
            updateState.name = { state: constants_1.ProgressState.Success };
        }
        if (util_1.isNullOrUndefined(this.email) || validator.isEmpty(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Email can't be blank."
                }
            });
        } else if (!validator.isEmail(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Not valid email format."
                }
            });
        } else {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (validator.isEmpty(this.subject)) {
            valid = false;
            updateState.subject = {
                state: constants_1.ProgressState.Failed,
                errorMessage: "Subject is required."
            };
        } else {
            updateState.subject = { state: constants_1.ProgressState.Success };
        }
        if (validator.isEmpty(this.message)) {
            valid = false;
            updateState.message = {
                state: constants_1.ProgressState.Failed,
                errorMessage: "Message is required."
            };
        } else {
            updateState.message = { state: constants_1.ProgressState.Success };
        }
        this.setState(updateState);
        return valid;
    }
}
exports.default = react_redux_1.connect(null, mapDispatchToProps)(ContactUsPart);


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/ContactUsPart.tsx
// module id = 1098
// module chunks = 0 1